import { useState, useEffect } from "react";
import { useTheme } from "../ThemeProvider";
import PropietarioBuscarOCrear from "./PropietarioBuscarOCrear";
import ModalCrearPropietario from "./ModalCrearPropietario";
import ModalCrearContactoAsociado from "./ModalCrearContactoAsociado";
import BuscadorContacto from "../contactos/BuscadorContacto";
import usePermiso from "../../hooks/usePermiso";
import { usePropiedadUi } from "../../hooks/usePropiedadUi";

const COMUNICACION_GROUP = "contacto-comunicacion-propiedad";

function ComunicacionRadio({ checked, onSelect, title }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <input
        type="radio"
        name={COMUNICACION_GROUP}
        checked={checked}
        onChange={onSelect}
        title={title || "Contacto para comunicación (llamadas, WhatsApp, email)"}
        aria-label={title || "Contacto para comunicación"}
        style={{
          width: 18,
          height: 18,
          margin: 0,
          cursor: "pointer",
          accentColor: "#2563eb",
        }}
      />
    </div>
  );
}

export default function SeccionPropietarios(props) {
  const {
    propietarios,
    setPropietarios,
    contactosAsociados,
    setContactosAsociados,
    contactoComunicacionId,
    setContactoComunicacionId,
    placesLocalityHint = null,
  } = props;
  const { tv } = usePropiedadUi(props);
  const { theme } = useTheme();
  const isDark = theme.name === "dark";
  const { puede } = usePermiso();
  const puedeVerNombreProp = puede("nombre_propietario", "ver");
  const puedeVerTelefonoProp = puede("telefono_propietario", "ver");
  const puedeVerEmailProp = puede("email_propietario", "ver");
  const puedeVerEditarEliminarProp = puede("prop_editar_eliminar", "ver");
  const puedeModificarEditarEliminarProp = puede("prop_editar_eliminar", "modificar");
  const puedeVerBuscarExistenteProp = puede("prop_buscar_existente", "ver");
  const puedeVerCrearNuevoProp = puede("prop_crear_nuevo", "ver");
  const puedeVerContactosAsociados = puede("prop_contactos_asociados", "ver");
  const puedeModificarContactosAsociados = puede("prop_contactos_asociados", "modificar");
  const puedeAltaContactosAsociados = puede("prop_contactos_asociados", "alta");
  const puedeBajaContactosAsociados = puede("prop_contactos_asociados", "baja");

  const [modalCrearProp, setModalCrearProp] = useState(false);
  const [textoBusquedaProp, setTextoBusquedaProp] = useState("");
  const [propietarioEditando, setPropietarioEditando] = useState(null);
  const [modalCrearCont, setModalCrearCont] = useState(false);
  const [contactoEditando, setContactoEditando] = useState(null);

  useEffect(() => {
    const hayFlag = [...propietarios, ...contactosAsociados].some(
      (p) => p && (p.comunicacion || p.contacto_principal)
    );
    if (contactoComunicacionId || hayFlag) return;
    const ids = [
      ...propietarios.map((p) => p.contacto_id || p.id).filter(Boolean),
      ...contactosAsociados.map((c) => c.contacto_id || c.id).filter(Boolean),
    ].map(String);
    if (ids.length) {
      setContactoComunicacionId(ids[0]);
    }
  }, [propietarios, contactosAsociados, contactoComunicacionId, setContactoComunicacionId]);

  const seleccionarComunicacion = (persona) => {
    if (!persona) return;
    const id = persona.contacto_id || persona.id;
    if (id) setContactoComunicacionId(id);
  };

  const esComunicacionPersona = (p) => {
    if (!p) return false;
    if (contactoComunicacionId) {
      if (p.contacto_id && String(contactoComunicacionId) === String(p.contacto_id)) return true;
      if (p.id != null && String(contactoComunicacionId) === String(p.id)) return true;
      return false;
    }
    return !!(p.contacto_principal || p.comunicacion);
  };

  const pctRestante = () => {
    const usado = propietarios.reduce((s, p) => s + (Number(p.porcentaje) || 0), 0);
    const rest = 100 - usado;
    return rest > 0 ? rest : 100;
  };

  const addPropDesdeContacto = (c) => {
    setPropietarios([...propietarios, {
      id: crypto.randomUUID(),
      contacto_id: c.id,
      nombre: c.nombre,
      apellidos: c.apellidos || "",
      telefono: c.telefono || "",
      email: c.email || "",
      dni_nie: c.dni_nie || "",
      direccion: c.direccion || "",
      poblacion: c.poblacion || "",
      provincia: c.provincia || "",
      codigo_postal: c.codigo_postal || "",
      porcentaje: pctRestante(),
    }]);
  };
  const addPropCreado = (p) => setPropietarios([...propietarios, p]);
  const actualizarProp = (p) => setPropietarios(propietarios.map((x) => (x.id === p.id ? p : x)));
  const delProp = (id) => setPropietarios(propietarios.filter(p => p.id !== id));

  const btnAccionSt = {
    fontSize: 12,
    background: "none",
    border: "none",
    cursor: "pointer",
    fontWeight: 600,
    padding: "2px 4px",
  };

  const addContDesdeContacto = (c) => {
    setContactosAsociados([...contactosAsociados, { id: crypto.randomUUID(), contacto_id: c.id, nombre: c.nombre, apellidos: c.apellidos || "", telefono: c.telefono || "", email: c.email || "", rol: "" }]);
  };
  const addContCreado = (c) => setContactosAsociados([...contactosAsociados, c]);
  const actualizarCont = (c) => setContactosAsociados(contactosAsociados.map((x) => (x.id === c.id ? c : x)));
  const delCont = (id) => setContactosAsociados(contactosAsociados.filter(c => c.id !== id));

  const thSt = { textAlign: "left", padding: "14px 12px", fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", color: isDark ? "#9ca3af" : "#6b7280", background: isDark ? "#1f2937" : "#f9fafb", lineHeight: 1.6 };
  const tdSt = { padding: "18px 12px", fontSize: 13, lineHeight: 1.9, color: isDark ? "#f3f4f6" : "#111827", borderBottom: `1px solid ${isDark ? "#374151" : "#f3f4f6"}` };
  const thComSt = { ...thSt, textAlign: "center", width: 56 };
  const tdComSt = { ...tdSt, textAlign: "center", width: 56, verticalAlign: "middle" };
  const sepSt = { fontSize: 11, color: isDark ? "#6b7280" : "#9ca3af", margin: "8px 0 6px" };

  return (
    <div>
      {/* ── PROPIETARIOS ── */}
      <div style={{ marginBottom: 32 }}>
        <h3 style={{ fontSize: 13, fontWeight: 700, color: isDark ? "#f3f4f6" : "#374151", marginBottom: 16, lineHeight: 1.6 }}>
          {tv("Propietarios")}
        </h3>
        {propietarios.length > 0 && (
          <table style={{ width: "100%", marginBottom: 20, borderCollapse: "collapse" }}>
            <thead><tr>
              <th style={thComSt} title={tv("Contacto para comunicación")}>{tv("Com.")}</th>
              {puedeVerNombreProp && <th style={thSt}>{tv("Nombre")}</th>}<th style={thSt}>{tv("Apellidos")}</th>
              {puedeVerTelefonoProp && <th style={thSt}>{tv("Teléfono")}</th>}{puedeVerEmailProp && <th style={thSt}>{tv("Email")}</th>}
              <th style={{ ...thSt, width: 60 }}>%</th>{puedeVerEditarEliminarProp && <th style={{ ...thSt, width: 100 }}></th>}
            </tr></thead>
            <tbody>{propietarios.map(p => (
              <tr key={p.id}>
                <td style={tdComSt}>
                  <ComunicacionRadio
                    checked={esComunicacionPersona(p)}
                    onSelect={() => seleccionarComunicacion(p)}
                    title={`Comunicación: ${[p.nombre, p.apellidos].filter(Boolean).join(" ")}`}
                  />
                </td>
                {puedeVerNombreProp && <td style={{ ...tdSt, fontWeight: 600 }}>{p.nombre}</td>}
                <td style={tdSt}>{p.apellidos || "—"}</td>
                {puedeVerTelefonoProp && <td style={tdSt}>{p.telefono || "—"}</td>}
                {puedeVerEmailProp && <td style={tdSt}>{p.email || "—"}</td>}
                <td style={tdSt}>{p.porcentaje}%</td>
                {puedeVerEditarEliminarProp && (
                <td style={{ ...tdSt, textAlign: "right" }}>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: 10, justifyContent: "flex-end" }}>
                    <button
                      type="button"
                      aria-label="Editar propietario"
                      onClick={() => { if (puedeModificarEditarEliminarProp) setPropietarioEditando(p); }}
                      disabled={!puedeModificarEditarEliminarProp}
                      style={{
                        ...btnAccionSt,
                        color: isDark ? "#60a5fa" : "#2563eb",
                        fontSize: 16,
                        lineHeight: 1,
                        cursor: puedeModificarEditarEliminarProp ? "pointer" : "not-allowed",
                        opacity: puedeModificarEditarEliminarProp ? 1 : 0.5,
                      }}
                      title={puedeModificarEditarEliminarProp ? tv("Editar propietario") : tv("No tienes permiso para modificar")}
                    >
                      <span aria-hidden>✎</span>
                    </button>
                    <button
                      type="button"
                      onClick={() => { if (puedeModificarEditarEliminarProp) delProp(p.id); }}
                      disabled={!puedeModificarEditarEliminarProp}
                      style={{
                        ...btnAccionSt,
                        color: "#ef4444",
                        cursor: puedeModificarEditarEliminarProp ? "pointer" : "not-allowed",
                        opacity: puedeModificarEditarEliminarProp ? 1 : 0.5,
                      }}
                      title={puedeModificarEditarEliminarProp ? tv("Eliminar propietario") : tv("No tienes permiso para modificar")}
                    >
                      {tv("Eliminar")}
                    </button>
                  </div>
                </td>
                )}
              </tr>
            ))}</tbody>
          </table>
        )}

        <PropietarioBuscarOCrear
          onSeleccionar={addPropDesdeContacto}
          onAbrirCrear={(texto) => {
            setTextoBusquedaProp(texto);
            setModalCrearProp(true);
          }}
          isDark={isDark}
          placeholder={tv("Nombre, teléfono o email...")}
          puedeVerBuscarExistente={puedeVerBuscarExistenteProp}
          puedeVerCrearNuevo={puedeVerCrearNuevoProp}
        />
        <ModalCrearPropietario
          open={modalCrearProp || Boolean(propietarioEditando)}
          propietarioEditar={propietarioEditando}
          textoBusqueda={modalCrearProp ? textoBusquedaProp : ""}
          placesLocalityHint={placesLocalityHint}
          onClose={() => { setModalCrearProp(false); setPropietarioEditando(null); setTextoBusquedaProp(""); }}
          onCreado={addPropCreado}
          onActualizado={actualizarProp}
          porcentajeInicial={propietarioEditando?.porcentaje ?? pctRestante()}
        />
      </div>

      <hr style={{ borderColor: isDark ? "#374151" : "#e5e7eb", margin: "32px 0 24px" }} />

      {/* ── CONTACTOS ASOCIADOS ── */}
      {puedeVerContactosAsociados && (
      <>
      <h3 style={{ fontSize: 13, fontWeight: 700, color: isDark ? "#f3f4f6" : "#374151", marginBottom: 20, lineHeight: 1.6 }}>
        {tv("Contactos asociados")}
      </h3>

      {contactosAsociados.length > 0 && (
        <table style={{ width: "100%", marginBottom: 20, borderCollapse: "collapse" }}>
          <thead><tr>
            <th style={thComSt} title={tv("Contacto para comunicación")}>{tv("Com.")}</th>
            <th style={thSt}>{tv("Nombre")}</th><th style={thSt}>{tv("Apellidos")}</th>
            <th style={thSt}>{tv("Teléfono")}</th><th style={thSt}>{tv("Email")}</th>
            <th style={thSt}>{tv("Rol")}</th><th style={{ ...thSt, width: 100 }}></th>
          </tr></thead>
          <tbody>{contactosAsociados.map(c => (
            <tr key={c.id}>
              <td style={tdComSt}>
                <ComunicacionRadio
                  checked={esComunicacionPersona(c)}
                  onSelect={() => seleccionarComunicacion(c)}
                  title={`Comunicación: ${[c.nombre, c.apellidos].filter(Boolean).join(" ")}${c.rol ? ` (${c.rol})` : ""}`}
                />
              </td>
              <td style={{ ...tdSt, fontWeight: 600 }}>{c.nombre}</td>
              <td style={tdSt}>{c.apellidos || "—"}</td>
              <td style={tdSt}>{c.telefono || "—"}</td>
              <td style={tdSt}>{c.email || "—"}</td>
              <td style={tdSt}>{c.rol || "—"}</td>
              <td style={{ ...tdSt, textAlign: "right" }}>
                <div style={{ display: "inline-flex", alignItems: "center", gap: 10, justifyContent: "flex-end" }}>
                  <button
                    type="button"
                    title={puedeModificarContactosAsociados ? tv("Editar contacto") : tv("No tienes permiso para modificar")}
                    aria-label="Editar contacto"
                    onClick={() => { if (puedeModificarContactosAsociados) setContactoEditando(c); }}
                    disabled={!puedeModificarContactosAsociados}
                    style={{
                      ...btnAccionSt,
                      color: isDark ? "#34d399" : "#059669",
                      fontSize: 16,
                      lineHeight: 1,
                      cursor: puedeModificarContactosAsociados ? "pointer" : "not-allowed",
                      opacity: puedeModificarContactosAsociados ? 1 : 0.5,
                    }}
                  >
                    <span aria-hidden>✎</span>
                  </button>
                  {puedeBajaContactosAsociados && (
                    <button type="button" onClick={() => delCont(c.id)} style={{ ...btnAccionSt, color: "#ef4444" }}>{tv("Eliminar")}</button>
                  )}
                </div>
              </td>
            </tr>
          ))}</tbody>
        </table>
      )}

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
        <span style={{ fontSize: 12, color: isDark ? "#9ca3af" : "#6b7280", whiteSpace: "nowrap" }}>{tv("Buscar existente:")}</span>
        <BuscadorContacto onSeleccionar={addContDesdeContacto} isDark={isDark} placeholder="Nombre, teléfono o email..." />
      </div>
      {puedeAltaContactosAsociados && (
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 4, flexWrap: "wrap" }}>
        <span style={sepSt}>{tv("— o crear nuevo contacto —")}</span>
        <button
          type="button"
          onClick={() => setModalCrearCont(true)}
          style={{
            padding: "8px 18px",
            background: "#059669",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          + {tv("Crear contacto asociado")}
        </button>
      </div>
      )}
      <ModalCrearContactoAsociado
        open={modalCrearCont || Boolean(contactoEditando)}
        contactoEditar={contactoEditando}
        onClose={() => { setModalCrearCont(false); setContactoEditando(null); }}
        onCreado={addContCreado}
        onActualizado={actualizarCont}
      />
      </>
      )}
    </div>
  );
}
